export default __webpack_public_path__ + "static/phillip-1e9af7ba26d356083a07867973f992bb.png";